var allObj = {
        ChronicOptions: {
                shortcuts: [{
                                text: '最近一周',
                                onClick(picker) {
                                        const end = new Date()
                                        const start = new Date()
                                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                                        picker.$emit('pick', [start, end])
                                },
                        },
                        {
                                text: '最近一个月',
                                onClick(picker) {
                                        const end = new Date()
                                        const start = new Date()
                                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                                        picker.$emit('pick', [start, end])
                                },
                        },
                        {
                                text: '最近三个月',
                                onClick(picker) {
                                        const end = new Date()
                                        const start = new Date()
                                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                                        picker.$emit('pick', [start, end])
                                },
                        },
                ],
        },
        sexList: [
                {
                  value: '',
                  label: '全部',
                },
                {
                  value: '1',
                  label: '男',
                },
                {
                  value: '0',
                  label: '女',
                },
              ],

}
export {
        allObj
}